export const checkoutMessages = {
  quotePending: "Estamos preparando el resumen de tu curso…",
  quoteError: "No pudimos calcular el precio de estos cursos.",
  quoteRecovery: "Vuelve al catálogo y elige un curso disponible.",
  emptyTitle: "Tu selección está vacía",
  emptyBody: "Elige un curso y vuelve aquí para continuar.",
  catalog: "Ver los cursos",
  ownedTitle: "Este aprendizaje ya es tuyo",
  ownedBody: "Estos cursos ya están en tu cuenta y no se volverán a cobrar.",
  access: "Acceso al curso completo",
  lessons: (count: number) =>
    `${count} ${count === 1 ? "clase" : "clases"} · Acceso completo`,
  codeLabel: "¿Tienes un código de descuento?",
  codePlaceholder: "Escribe tu código",
  codeApply: "Aplicar",
  codeApplying: "Validando…",
  codeRemove: "Quitar",
  codeApplied: (percent: number) => `${percent}% de descuento aplicado`,
  codeInvalid: "Ese código no es válido o ya fue usado.",
  codeError: "No pudimos validar el código. Inténtalo de nuevo.",
  codeExpired: "El código dejó de ser válido. Quítalo para continuar.",
  subtotal: "Subtotal",
  discount: "Descuento",
  total: "Total a pagar",
  priceWas: "Antes",
  quoteAuthority: "El precio y la moneda se confirman antes del pago.",
  accountNote:
    "Con ese correo creamos tu cuenta: ahí quedan tu curso, tu progreso y tu certificado.",
  signedIn: "Ya estás dentro",
  signedInBody:
    "Tu curso quedará vinculado a esta cuenta. Continúa para revisar el pago.",
  changeAccount: "Usar otra cuenta",
  changingAccount: "Cambiando de cuenta…",
  signOutError: "No pudimos cerrar tu sesión. Inténtalo de nuevo.",
  email: "Tu correo electrónico",
  emailPlaceholder: "tu@correo.com",
  emailHelp:
    "Ahí te enviamos el acceso y un código para activar tu cuenta. Revisa que esté bien escrito.",
  emailInvalid: "Escribe un correo válido, como nombre@gmail.com.",
  emailOwnsCourse:
    "Ese correo ya tiene este curso. Inicia sesión con él para verlo.",
  validationError: "Revisa los campos marcados para continuar.",
  existingAccount: "¿Ya tienes una cuenta?",
  login: "Inicia sesión",
  pay: "Pagar y obtener acceso",
  paying: "Abriendo el pago seguro…",
  paymentError: "No pudimos iniciar el pago. Inténtalo de nuevo.",
  secure: "Pago seguro procesado por Stripe",
} as const;
export const checkoutLandingUrl =
  import.meta.env.VITE_LANDING_URL || "https://hey404.com/#cursos";
